import { useContext } from 'react';

import { QueryParamsContext } from './queryParams.context';

const useQueryParams = () => {
  const { params, setParams } = useContext(QueryParamsContext);
  return [params, setParams] as const;
};

export default useQueryParams;
